import React, { useState, useEffect } from "react";
import MakeAPICall from "../../apiCalls/common";
import { appSettingsApiRoute, getConstansApiRoute, updateConstantsApiRoute } from "../../apiRoutes";
import CustomModal from "../../components/modal";
import PublicLayout from "../../containers/Layout/PublicLayout";
import AppSettingsForm from "../../containers/AppSettingsForm";
import MIMSConfigForm from "../../containers/MIMSConfigForm";

const AppSettings = props => {
  const [errorMsg, setErrorMsg] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isMIMSProcessing, setIsMIMSProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [apiCallParams2, setApiCallParams2] = useState(null);
  const [showSuccessModal, setSuccessModalState] = useState(false);
  const [showMIMSSuccessModal, setMIMSSuccessModalState] = useState(false);
  const [showRotateSuccessModal, setRotateSuccessModalState] = useState(false);
  const [rotateMessage, setRotateMessage] = useState("");

  const [data, setData] = useState();
  const [constantsData, setConstantsData] = useState();

  useEffect(() => {
    // Load app settings
    setApiCallParams({
      reqType: "GET",
      reqUrl: appSettingsApiRoute,
      dataObj: {},
      successCallback: res => {
        if (res.data.data) setData(res.data.data);
        else console.log("Response empty", res.data.data);
      },
      failureCallback: err => {
        console.log(err);
      }
    });

    // Load constants for MIMS config
    setApiCallParams2({
      reqType: "GET",
      reqUrl: getConstansApiRoute,
      dataObj: {},
      successCallback: res => {
        if (res.data.data) setConstantsData(res.data.data);
        else console.log("Constants response empty", res.data.data);
      },
      failureCallback: err => {
        console.log(err);
      }
    });
  }, []);

  const onAppSettingsSubmit = async formValues => {
    setIsProcessing(true);

    await setApiCallParams({
      reqType: "PUT",
      reqUrl: appSettingsApiRoute + "/update",
      dataObj: {
        iosVersion: formValues.iosVersion,
        androidVersion: formValues.androidVersion,
        maxNoOfPatientsInQueue: formValues.maxNoOfPatientsInQueue,
        isIOSRedirect: {
          isRedirect: formValues.isIOSRedirect,
          redirectTo: formValues.iOSRedirectTo,
          message: formValues.iOSMessage
        }, isAndroidRedirect: {
          isRedirect: formValues.isAndroidRedirect,
          redirectTo: formValues.androidRedirectTo,
          message: formValues.androidMessage
        }
      },
      successCallback: res => {
        setSuccessModalState(true);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };

  const onMIMSConfigSubmit = (formValues) => {
    setIsMIMSProcessing(true);
    
    let formData = new FormData();
    
    // Send as direct keys instead of nested mimsConfig object
    if (formValues.endUserLicenseAgreementRevisionDate) {
      formData.append("endUserLicenseAgreementRevisionDate", formValues.endUserLicenseAgreementRevisionDate);
    }

    setApiCallParams2({
      reqType: "PUT",
      reqUrl: updateConstantsApiRoute,
      dataObj: formData,
      successCallback: res => {
        setMIMSSuccessModalState(true);
        setIsMIMSProcessing(false);
        // Reload constants data
        loadConstants();
      },
      failureCallback: err => {
        setIsMIMSProcessing(false);
      }
    });
  };

  const loadConstants = () => {
    setApiCallParams2({
      reqType: "GET",
      reqUrl: getConstansApiRoute,
      dataObj: {},
      successCallback: res => {
        if (res.data.data) setConstantsData(res.data.data);
        else console.log("Constants response empty", res.data.data);
      },
      failureCallback: err => {
        console.log(err);
      }
    });
  };

  const closeModal = () => {
    setSuccessModalState(false);
  };

  const closeMIMSModal = () => {
    setMIMSSuccessModalState(false);
  };

  const handleRotateSuccess = (message) => {
    setRotateMessage(message);
    setRotateSuccessModalState(true);
  };

  const handleRotateError = (message) => {
    setRotateMessage(message);
    setRotateSuccessModalState(true);
  };

  const closeRotateModal = () => {
    setRotateSuccessModalState(false);
    setRotateMessage("");
  };

  return (
    <div className="view-ticket-container">
      <CustomModal
        cancelText="OKAY"
        openModal={showSuccessModal}
        cancelEvent={closeModal}
        modalBodyContent={
          <p className="text-center mb-0">
            App Settings updated Successfully
          </p>
        }
        useOneButton={true}
      />
      <CustomModal
        cancelText="OKAY"
        openModal={showMIMSSuccessModal}
        cancelEvent={closeMIMSModal}
        modalBodyContent={
          <p className="text-center mb-0">
            MIMS Configuration updated Successfully
          </p>
        }
        useOneButton={true}
      />
      <CustomModal
        cancelText="OKAY"
        openModal={showRotateSuccessModal}
        cancelEvent={closeRotateModal}
        modalBodyContent={
          <p className="text-center mb-0">
            {rotateMessage}
          </p>
        }
        useOneButton={true}
      />
      <h3 className="mb-4">Settings</h3>
      
      {/* App Settings Section */}
      <div className="mb-5">
        <h4 className="mb-3">App Configuration</h4>
        <AppSettingsForm
          data={data}
          onFormSubmit={onAppSettingsSubmit}
          serverErrorMsg={errorMsg}
          isProcessing={isProcessing}
        />
      </div>

      {/* MIMS Config Section */}
      <div className="mb-5">
        <h4 className="mb-3">MIMS Configuration</h4>
        <div className="row">
          <div className="col-md-6">
            <MIMSConfigForm
              data={constantsData}
              onFormSubmit={onMIMSConfigSubmit}
              serverErrorMsg={errorMsg}
              isProcessing={isMIMSProcessing}
              onRotateSuccess={handleRotateSuccess}
              onRotateError={handleRotateError}
            />
          </div>
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
      <MakeAPICall apiParam={apiCallParams2} />
    </div>
  );
};

export default AppSettings;
